// WS-3 · Barra de envío gratis (Devenir Café) — actualización en vivo.
// Escucha el evento nativo 'cart:update' de Horizon y repinta todas las barras.
const fmt = (pesos) => '$' + Math.max(0, Math.round(pesos)).toLocaleString('es-CO');

function paint(bar, totalCents) {
  const threshold = parseInt(bar.dataset.fsbThreshold, 10) || 0; // en pesos
  if (threshold <= 0) return;
  const totalPesos = totalCents / 100;
  const remaining = threshold - totalPesos;
  const msg = bar.querySelector('[data-fsb-message]');
  const fill = bar.querySelector('[data-fsb-fill]');
  const pbar = bar.querySelector('[role="progressbar"]');
  let pct;
  let text;
  let empty = false;
  let complete = false;

  if (totalPesos <= 0) {
    pct = 0;
    empty = true;
    text = bar.dataset.fsbTextEmpty || '';
  } else if (remaining <= 0) {
    pct = 100;
    complete = true;
    text = bar.dataset.fsbTextSuccess || '';
  } else {
    pct = Math.min(100, Math.round((totalPesos / threshold) * 100));
    text = (bar.dataset.fsbTextProgress || '').replace('[faltante]', fmt(remaining));
  }

  bar.classList.toggle('is-empty', empty);
  bar.classList.toggle('is-complete', complete);
  if (msg) msg.textContent = text;
  if (fill) fill.style.width = pct + '%';
  if (pbar) pbar.setAttribute('aria-valuenow', String(pct));
}

function paintAll(totalCents) {
  document.querySelectorAll('[data-fsb]').forEach((bar) => paint(bar, totalCents));
}

function cartUrl() {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root.replace(/\/$/, '') + '/cart.js';
}

async function fetchTotal() {
  try {
    const res = await fetch(cartUrl(), { headers: { Accept: 'application/json' } });
    if (!res.ok) return null;
    const cart = await res.json();
    return typeof cart.total_price === 'number' ? cart.total_price : null;
  } catch (_) {
    return null;
  }
}

// Refuerzo del gate server-side: ocultar si el visitante no está en Colombia.
function geoGate() {
  const country = window.Shopify && window.Shopify.country;
  if (country && country !== 'CO') {
    document.querySelectorAll('[data-fsb]').forEach((bar) => {
      bar.style.display = 'none';
    });
  }
}

// Fase 2 · CTA "Completa tu pedido ↓" (PDP) → scroll suave al bloque cross-sell.
// Si el ancla no existe (p.ej. sin cafés en stock para mostrar), se oculta el CTA.
function initCta() {
  const ctas = document.querySelectorAll('[data-fsb-cta]');
  if (!ctas.length) return;
  const target = document.querySelector('#completa-tu-ritual');
  ctas.forEach((cta) => {
    if (!target) {
      cta.style.display = 'none';
      return;
    }
    cta.addEventListener('click', (event) => {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

let pending = false;
document.addEventListener('cart:update', async (event) => {
  let total = event && event.detail && event.detail.resource && event.detail.resource.total_price;
  if (typeof total !== 'number') {
    if (pending) return;
    pending = true;
    total = await fetchTotal();
    pending = false;
  }
  if (typeof total === 'number') paintAll(total);
});

geoGate();
initCta();
